import { lazy } from "react";
import type { RouteObject } from "react-router-dom";
import { canAccessSearch } from "@/utils/roles";
import { ROUTES } from "./constants";
import { AuthGuard, protectedRoute, roleProtectedRoute } from "./helpers";

// Auth
const SignIn = lazy(() => import("@/features/sign-in"));

// Core Pages
const DashboardPage = lazy(() => import("@/features/dashboard"));
const MapPage = lazy(() => import("@/features/map"));
const SearchResults = lazy(() => import("@/features/search"));
const Methods = lazy(() => import("@/features/methodologies"));
const CuriosityV2Route = lazy(
	() => import("@/features/curiosity-v2/app/CuriosityV2Route"),
);

// File Viewer (import concrete module, not barrel, to avoid pulling extras)
const FileViewer = lazy(
	() => import("../einstein/components/fileViewer/FileViewer"),
);

export const coreRoutes: RouteObject[] = [
	{
		path: ROUTES.LOGIN,
		element: (
			<AuthGuard>
				<SignIn />
			</AuthGuard>
		),
	},
	{
		path: ROUTES.HOME,
		element: protectedRoute(<DashboardPage />),
	},
	{
		path: ROUTES.MAP,
		element: protectedRoute(<MapPage />),
	},
	{
		path: ROUTES.METHODOLOGIES,
		element: protectedRoute(<Methods />),
	},
	{
		path: ROUTES.FILE_VIEWER,
		element: protectedRoute(<FileViewer />),
	},
];

export const searchRoutes: RouteObject[] = [
	{
		path: ROUTES.SEARCH,
		element: roleProtectedRoute(<SearchResults />, canAccessSearch),
	},
];

export const curiosityRoutes: RouteObject[] = [
	{
		path: `${ROUTES.CURIOSITY}/:conversationId?`,
		element: protectedRoute(<CuriosityV2Route />),
	},
];

export const curiosityV2Routes: RouteObject[] = [
	{
		path: `${ROUTES.CURIOSITY_V2}/:conversationId?`,
		element: protectedRoute(<CuriosityV2Route />),
	},
];
